import React from 'react';
import Reflux from 'reflux';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import {
  ColorRGBs,
  RTEFontSizeArray,
} from 'flux/stores/cuesheet/CuesheetConstants';
import classnames from 'classnames';
import { convertToRaw, EditorState, KeyBindingUtil } from 'draft-js';
import { applyInlineFormattingToEditorState } from 'shared/lib/rteHelper';
import { Editor } from 'react-draft-wysiwyg';
import draftUtils from '@shoflo-rundown/draft-js-utils';
import { fromJS } from 'immutable';
import RTEActions from 'flux/actions/RTEActions';

const { hasCommandModifier } = KeyBindingUtil;
const CustomColorConfig = ColorRGBs;
const DefaultEditorState = EditorState.createEmpty();

export default React.createClass({
  mixins: [Reflux.ListenerMixin, PureRenderMixin],

  propTypes: {
    rteState: React.PropTypes.object,
    height: React.PropTypes.number,
    editorClassName: React.PropTypes.string,
    toolbarClassName: React.PropTypes.string,
    displayToolbar: React.PropTypes.bool,
    autoFocus: React.PropTypes.bool,
    onContentChange: React.PropTypes.func,
    onExternalContentChange: React.PropTypes.func,
    onScroll: React.PropTypes.func,
    disableBlur: React.PropTypes.bool,
  },

  getInitialState() {
    const { editorState, onExternalContentChange } = this.props;
    let initialEditorState = editorState || null;
    onExternalContentChange(initialEditorState);
    return {
      editorState: initialEditorState,
      editorHeight: this.props.height,
    };
  },

  getDefaultProps() {
    return {
      displayToolbar: false,
      readOnly: false,
      disableBlur: false,
    };
  },

  componentDidMount() {
    if (this.props.autoFocus && this._rteEditor) this._rteEditor.focusEditor();
    this.listenTo(
      RTEActions.applyInlineFormatting,
      this._applyInlineFormatting,
    );
  },

  componentDidUpdate(prevProps) {
    const { editorState, readOnly } = this.props;
    if (readOnly && prevProps.editorState !== editorState) {
      this.setState({ editorState });
    }
  },

  componentWillReceiveProps(nextProps) {
    const { readOnly } = nextProps;
    if (readOnly && readOnly !== this.props.readOnly) {
      this.setState({ editorState: null });
    }
  },

  componentWillUnmount() {
    if (this.state.editorState && this.props.onWillUnmount) {
      const currentContentState = this.state.editorState.getCurrentContent();
      const rawContentState = convertToRaw(currentContentState);
      this.props.onWillUnmount(fromJS(rawContentState));
    }
  },

  render() {
    let {
      wrapperClassName,
      toolbarClassName,
      editorClassName,
      displayToolbar,
      height,
      partialCell,
      readOnly,
      placeholder,
      viewType,
      scrollTop,
      onScroll,
    } = this.props;

    let editorNodeProps = {
      ref: (e) => {
        if (!e) return;

        this._rteEditorWrapper = e.getWrapperRef();
        this._rteEditorWrapper.setAttribute('aria-label', 'RTE Editor Wrapper');

        if (scrollTop) this._rteEditorWrapper.scrollTop = scrollTop;
        if (onScroll) this._rteEditorWrapper.onscroll = onScroll;

        this._rteEditor = e;
      },
      wrapperClassName: classnames('rte-wrapper', wrapperClassName),
      placeholder,
      readOnly,
      onTab: this._handleTab,
      toolbarClassName: classnames('rte-toolbar', toolbarClassName, {
        'rte-hide-toolbar': !displayToolbar,
      }),
      editorClassName: classnames('rte-editor', editorClassName),
      onEditorStateChange: this._handleChange,
      onBlur: this._handleBlur,
      defaultEditorState: DefaultEditorState,
    };

    editorNodeProps.editorState =
      this.state.editorState || this.props.editorState;
    if (!editorNodeProps.editorState && !editorNodeProps.defaultEditorState)
      return <div />;

    const editorStyle = { minHeight: this.state.minHeight };

    const wrapperStyle = {};

    if (partialCell) {
      delete editorStyle.minHeight;
      wrapperStyle.minHeight = height;
    }

    let toolbarStyle = {};

    if (viewType === 'featured') {
      editorStyle.height = height;
    }

    if (viewType === 'prompter') {
      toolbarStyle = this.props.toolbarStyle;
    }

    return (
      <div
        data-testid="rte-editor-wrapper"
        style={wrapperStyle}
        ref="wrapper"
        aria-label="Editor Wrapper"
        onKeyDown={(e) => {
          const enterKey = 13;

          let { isEditing, onKeyDown } = this.props;

          if (isEditing && e.keyCode === enterKey && hasCommandModifier(e)) {
            this._handleBlur(this.state.editorState);
            if (onKeyDown) onKeyDown();
          }
        }}
      >
        <Editor
          {...editorNodeProps}
          editorStyle={editorStyle}
          toolbarStyle={toolbarStyle}
          spellCheck
          toolbar={{
            options: [
              'inline',
              'fontSize',
              'colorPicker',
              'list',
              'textAlign',
              'link',
              'remove',
              'history',
            ],
            inline: {
              options: ['bold', 'italic', 'underline'],
              bold: {
                className: 'rte-toolbar-item',
              },
              italic: {
                className: 'rte-toolbar-item',
              },
              underline: {
                className: 'rte-toolbar-item',
              },
            },
            textAlign: {
              inDropdown: true,
              options: ['left', 'center', 'right'],
              left: {
                className: 'rte-toolbar-item',
              },
              center: {
                className: 'rte-toolbar-item',
              },
              right: {
                className: 'rte-toolbar-item',
              },
              justify: {
                className: 'rte-toolbar-item',
              },
            },
            fontSize: {
              options: RTEFontSizeArray,
            },
            colorPicker: {
              className: 'rte-toolbar-item',
              colors: CustomColorConfig,
            },
            remove: {
              className: 'rte-toolbar-item',
            },
            history: {
              options: ['undo', 'redo'],
              undo: {
                className: 'rte-toolbar-item',
              },
              redo: {
                className: 'rte-toolbar-item',
              },
            },
            link: {
              options: ['link', 'unlink'],
              link: {
                className: 'rte-toolbar-item',
              },
              unlink: {
                className: 'rte-toolbar-item',
              },
            },
            list: {
              options: ['unordered'],
              unorderered: {
                classname: 'rte-toolbar-item',
              },
            },
          }}
        />
      </div>
    );
  },

  _focusEditor() {
    if (this._rteEditor) {
      this._rteEditor.focusEditor();
    }
  },

  _applyInlineFormatting(styles) {
    let editorState = this._rteEditor.state.editorState;

    editorState = applyInlineFormattingToEditorState(editorState, styles);

    this._handleChange(editorState);
  },

  _editorHasFocus() {
    return document.activeElement.className.indexOf(
      'public-DraftEditor-content',
    );
  },

  _handleChange(editorState) {
    //If we have already blurred out, don't fire this handler
    //...when you use the tab key to blur out, this handler is fired _after_ the
    //... editor has blurred and lost focus...we don't want that
    if (this._blurred) return;

    if (!this._editorHasFocus()) {
      this._focusEditor();
    }

    const { onExternalContentChange } = this.props;

    /**
     * Why do we need onExternalContentChange?
     *
     * This allows us to monitor the state changes from outside
     * of the rte component and save the content via different triggers
     * other than the cell losing focus.
     */
    if (onExternalContentChange && editorState) {
      onExternalContentChange(editorState);
    }
    this.setState({ editorState });
  },

  _handleTab(e) {
    if (this.props.onTab) this.props.onTab(e);
    this._handleBlur();
  },

  _handleBlur() {
    let { editorState } = this.state;
    let { onContentChange, disableBlur } = this.props;

    /**
     * If blur is disabled then it means
     * another source to trigger the save.
     * For instance, a save button.
     */
    if (disableBlur) return;
    if (!editorState) return;

    const currentContentState = editorState.getCurrentContent();

    if (onContentChange) {
      onContentChange(
        fromJS(
          draftUtils.replaceTextInRawRTEState(
            convertToRaw(currentContentState),
            /\t/g,
            '   ',
          ),
        ),
      );
      this._blurred = true;
    }
  },
});
